import styles from './Leaderboard.module.css';
import LeaderboardHeader from './LeaderboardHeader/LeaderboardHeader.tsx';
import BalanceTop from '../../components/BalanceTop/BalanceTop.tsx';
import LeaderboardInfo from './LeaderboardInfo/LeaderboardInfo.tsx';
import Leaderboard from './LeaderBoard/Leaderboard.tsx';
import type { LeaderboardData } from './types/leaderboard.ts';
import { useEffect, useState } from 'react';
import { getLeaderboard } from '../../Requests/leaderboard/leaderboard.ts';
import CustomLoader from '../../components/CustomLoader/CustomLoader';
import type { WebApp } from '../../types/telegram';

interface ExtendedWebApp extends WebApp {
  contentSafeAreaInset?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}

const LeaderboardPage = () => {
  const [leaderboardData, setLeaderboardData] = useState<LeaderboardData>();
  const [isBackgroundLoaded, setIsBackgroundLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const tg = window.Telegram?.WebApp as ExtendedWebApp;
    if (!tg) return;

    console.log(window.Telegram?.WebApp.initData);

    const apply = () => {
      const top = tg?.contentSafeAreaInset?.top ?? 0;
      document.documentElement.style.setProperty(
        '--tg-viewport-content-safe-area-inset-top',
        `${top}px`,
      );
    };

    apply();
    tg.onEvent?.('contentSafeAreaChanged', apply);
    return () => tg.offEvent?.('contentSafeAreaChanged', apply);
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const initData = window.Telegram?.WebApp.initData;
      if (initData) {
        const data = await getLeaderboard(initData);
        console.log(data, 'data');
        if (data) {
          setLeaderboardData(data);
        }
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    console.log('Начинаем загрузку фонового изображения');
    const img = new Image();
    img.onload = () => {
      console.log('Фоновое изображение загружено успешно');
      setIsBackgroundLoaded(true);
    };
    img.onerror = () => {
      console.log('Ошибка загрузки фонового изображения, продолжаем без него');
      setIsBackgroundLoaded(true);
    };

    img.src = '@/assets/backgrounds/LeaderboardBackground.webp';

    const timeout = setTimeout(() => {
      console.log('Таймаут загрузки фонового изображения');
      setIsBackgroundLoaded(true);
    }, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const isAllLoaded = isBackgroundLoaded && !isLoading;

  // Показываем лоадер только через 2 секунды после начала загрузки
  useEffect(() => {
    if (!isAllLoaded) {
      const timer = setTimeout(() => {
        setShowLoader(true);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setShowLoader(false);
    }
  }, [isAllLoaded]);

  return (
    <div className={styles.container}>
      <LeaderboardHeader />

      <div className={styles.container__contentContainer}>
        {!isAllLoaded && (
          <div className={styles.container__loaderContainer}>
            <CustomLoader />
          </div>
        )}

        <div style={{ visibility: isAllLoaded ? 'visible' : 'hidden' }}>
          {/* <BalanceTop /> */}
          {/* <LeaderboardInfo /> */}
          {leaderboardData ? <Leaderboard data={leaderboardData} /> : null}
        </div>
      </div>
    </div>
  );
};

export default LeaderboardPage;
